var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
var loginBg = "https://web-static.hg-cdn.com/arknights/activity/utils/login-bg.3b6ef0d72c.png";
var gryphlineIcon = "https://web-static.hg-cdn.com/arknights/activity/utils/icon-gryphline.a7f3c9e21b.png";
var longchengIcon = "https://web-static.hg-cdn.com/arknights/activity/utils/icon-longcheng.f94d12ac8e.png";
var i18nText = {
    "login.title": "選擇登入方式",
    "login.gl_title": "已完成帳號遷移",
    "login.gl_desc": "帳號登入",
    "login.lc_title": "未完成帳號遷移",
    "login.lc_desc": "帳號遷移",
    "login.no_role": "您暫時未創建遊戲角色，無法參與活動",
    "login.text_loading": "讀取資料中，請稍候……",
};
var defaultFont = 'PingFangSC, "Microsoft YaHei", sans-serif';
var pxToRem = function (px) { return "".concat(px / 16, "rem"); };
var containerStyle = {
    position: "relative",
    width: pxToRem(600),
    height: pxToRem(420),
    borderRadius: pxToRem(9),
    backgroundImage: "url(".concat(loginBg, ")"),
    backgroundColor: "#e4e4e4",
    backgroundSize: "100% 100%",
};
var titleStyle = {
    position: "relative",
    width: "100%",
    height: pxToRem(88),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
var titleTextWrapperStyle = {
    display: "flex",
    alignItems: "center",
};
var titleTextStyle = {
    margin: "0 ".concat(pxToRem(20)),
    fontFamily: defaultFont,
    fontWeight: "bold",
    fontSize: pxToRem(30),
    lineHeight: 1,
    color: "#fff",
};
var closeWrapperStyle = {
    position: "absolute",
    top: pxToRem(32),
    right: pxToRem(20),
    width: pxToRem(24),
    height: pxToRem(24),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
};
var closeSvgStyle = {
    width: "100%",
    height: "100%",
};
var channelsStyle = {
    width: "100%",
    height: pxToRem(322),
    marginTop: pxToRem(4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
var dividerStyle = {
    width: pxToRem(2),
    height: pxToRem(180),
    margin: "0 ".concat(pxToRem(53)),
    backgroundColor: "#929292",
};
var channelStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
};
var channelNameStyle = {
    marginTop: pxToRem(17),
    fontFamily: defaultFont,
    fontWeight: "bold",
    fontSize: pxToRem(19),
    lineHeight: 1,
    color: "#343333",
};
var channelDescStyle = {
    marginTop: pxToRem(7),
    fontFamily: defaultFont,
    fontWeight: "bold",
    fontSize: pxToRem(19),
    lineHeight: 1,
    color: "#343333",
};
var channelTitleStyle = {
    fontFamily: defaultFont,
    fontWeight: "bold",
    fontSize: pxToRem(22),
    lineHeight: 1,
    color: "#181818",
};
var logoBaseStyle = {
    width: pxToRem(96),
    height: pxToRem(96),
    borderRadius: pxToRem(8),
    marginTop: pxToRem(38),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
var logoImageStyle = {
    display: "block",
    width: pxToRem(57),
    height: pxToRem(81),
    objectFit: "contain",
};
var logoLongChengImageStyle = {
    display: "block",
    width: pxToRem(36),
    height: pxToRem(64),
    objectFit: "contain",
};
export var CustomLogin = function (_a) {
    var onClose = _a.onClose, sdkLogin = _a.sdkLogin;
    var _b = __read(useState(false), 2), isCloseHover = _b[0], setIsCloseHover = _b[1];
    var t = function (path) { return i18nText[path]; };
    var doLogin = function () {
        sdkLogin();
        onClose();
    };
    return (_jsxs("div", { style: containerStyle, children: [_jsxs("div", { style: titleStyle, children: [_jsxs("div", { style: titleTextWrapperStyle, children: [_jsx("svg", { viewBox: "0 0 13 43", style: { width: 13, height: 43, transform: "scaleX(-1)" }, children: _jsx("path", { fillRule: "evenodd", fill: "rgb(6, 163, 218)", d: "M10.633,42.769 L0.918,42.769 L0.918,40.899 L10.633,40.899 L10.633,2.494 L0.918,2.494 L0.918,0.624 L10.633,0.624 L12.503,0.624 L12.503,2.494 L12.503,40.899 L12.503,42.769 L10.633,42.769 Z" }) }), _jsx("span", { style: titleTextStyle, children: t("login.title") }), _jsx("svg", { viewBox: "0 0 13 43", style: { width: 13, height: 43 }, children: _jsx("path", { fillRule: "evenodd", fill: "rgb(6, 163, 218)", d: "M10.633,42.769 L0.918,42.769 L0.918,40.899 L10.633,40.899 L10.633,2.494 L0.918,2.494 L0.918,0.624 L10.633,0.624 L12.503,0.624 L12.503,2.494 L12.503,40.899 L12.503,42.769 L10.633,42.769 Z" }) })] }), _jsx("div", { style: closeWrapperStyle, onClick: onClose, onMouseEnter: function () { return setIsCloseHover(true); }, onMouseLeave: function () { return setIsCloseHover(false); }, children: _jsx("svg", { viewBox: "0 0 24 24", style: closeSvgStyle, children: _jsx("path", { fillRule: "evenodd", d: "M23.663,21.120 L21.347,23.436 L0.791,2.880 L3.107,0.564 L12.227,9.684 L21.347,0.564 L23.663,2.880 L14.543,11.1000 L23.663,21.120 ZM9.934,16.609 L3.107,23.436 L0.791,21.120 L7.618,14.293 L9.934,16.609 Z", style: {
                                    fill: isCloseHover ? "#fff" : "#8f8f8f",
                                    transition: "fill 0.3s ease",
                                } }) }) })] }), _jsxs("div", { style: channelsStyle, children: [_jsxs("div", { style: channelStyle, onClick: doLogin, children: [_jsx("div", { style: channelTitleStyle, children: t("login.gl_title") }), _jsx("div", { style: __assign(__assign({}, logoBaseStyle), { backgroundColor: "#3b96da" }), children: _jsx("img", { src: gryphlineIcon, alt: "GRYPHLINE", style: logoImageStyle }) }), _jsx("div", { style: channelNameStyle, children: "GRYPHLINE" }), _jsx("div", { style: channelDescStyle, children: t("login.gl_desc") })] }), _jsx("div", { style: dividerStyle }), _jsxs("div", { style: channelStyle, onClick: function () {
                            return window.open("https://ak.gryphline.com/account-migration/");
                        }, children: [_jsx("div", { style: channelTitleStyle, children: t("login.lc_title") }), _jsx("div", { style: __assign(__assign({}, logoBaseStyle), { backgroundColor: "#929292" }), children: _jsx("img", { src: longchengIcon, alt: "LONG CHENG", style: logoLongChengImageStyle }) }), _jsx("div", { style: channelNameStyle, children: "LONG CHENG" }), _jsx("div", { style: channelDescStyle, children: t("login.lc_desc") })] })] })] }));
};
